import {DocRenderer} from '@cyntler/react-doc-viewer';
import React from 'react';
import TiffViewer from '../CustomViewers/TIFFViewer';
import {Buffer} from 'buffer';

const TiffRenderer: DocRenderer = ({mainState: {currentDocument}}) => {
  const bufferData = currentDocument?.uri?.replace(/^data:image\/tiff;base64,|^data:image\/tif;base64,/i, '');
  if (bufferData) {
    try {
      const buffer = Buffer.from(bufferData, 'base64');
      return (
        <div style={{willChange:"width, height, scale, min-width, max-width"}}>
          <TiffViewer tiffBuffer={buffer} />
        </div>
      );
    } catch (error) {
      console.error('Error decoding Base64 string:', error);
      // Handle the error case, e.g., display an error message
      return <div>Error loading TIFF viewer</div>;
    }
  } else {
    // Handle the case where bufferData is undefined
    // For example, you might want to display a loading message or placeholder
    return <div>Loading...</div>;
  }
};

TiffRenderer.fileTypes = [
  'tiff',
  'tif',
  'TIFF',
  'TIF',
  'image/tif',
  'image/tiff'
];
TiffRenderer.weight = 1;

export default TiffRenderer;
